{
  "scheduling": "Penjadualan Temu Janji",
  "date": "Tarikh",
  "time": "Masa",
  "duration": "Tempoh",
  "provider": "Doktor",
  "reason": "Sebab",
  "status": "Status",
  "statusOptions": {
    "scheduled": "Dijadualkan",
    "confirmed": "Disahkan",
    "arrived": "Sudah Tiba",
    "checked-in": "Sudah Daftar",
    "in-progress": "Dalam Proses",
    "completed": "Selesai",
    "cancelled": "Dibatalkan",
    "no-show": "Tidak Hadir"
  },
  "coverageScope": {
    "panel": "Panel Pesakit",
    "unit": "Unit",
    "facility": "Seluruh Kemudahan"
  },
  "coverageScopeDescription": {
    "panel": "Hanya panel pesakit doktor yang diliputi.",
    "unit": "Unit yang ditugaskan kepada doktor yang diliputi.",
    "facility": "Seluruh kemudahan — biasanya untuk aturan on-call."
  },
  "dayShort": {
    "0": "Ahd",
    "1": "Isn",
    "2": "Sel",
    "3": "Rab",
    "4": "Kha",
    "5": "Jum",
    "6": "Sab"
  },
  "blockType": {
    "available": "Tersedia",
    "blocked": "Disekat"
  },
  "appointmentTypes": {
    "followUp": "Susulan",
    "newPatient": "Pesakit baharu",
    "consultation": "Perundingan",
    "procedure": "Prosedur",
    "urgent": "Kecemasan",
    "wellnessCheck": "Pemeriksaan kesihatan",
    "physical": "Pemeriksaan fizikal",
    "telemedicine": "Teleperubatan",
    "scheduleTemplate": "Templat jadual"
  },
  "pages": {
    "providerDirectory": {
      "title": "Direktori Doktor",
      "subtitle": "Layari dan cari penyedia penjagaan kesihatan",
      "search": {
        "namePlaceholder": "Cari mengikut nama...",
        "specialtyPlaceholder": "Cari mengikut pengkhususan..."
      },
      "filters": {
        "facilityAriaLabel": "Tapis mengikut kemudahan",
        "departmentAriaLabel": "Tapis mengikut jabatan",
        "allFacilities": "Semua Kemudahan",
        "allDepartments": "Semua Jabatan"
      },
      "loading": "Memuatkan doktor...",
      "loadError": "Gagal memuatkan direktori doktor.",
      "empty": "Tiada doktor yang sepadan dengan kriteria anda.",
      "npiLabel": "NPI:"
    },
    "scheduleTemplateForm": {
      "title": "Cipta Templat Jadual",
      "labels": {
        "provider": "Doktor",
        "dayOfWeek": "Hari",
        "startTime": "Masa Mula",
        "endTime": "Masa Tamat",
        "slotDuration": "Tempoh slot (minit)",
        "templateName": "Nama Templat",
        "effectiveStartDate": "Berkuat Kuasa Dari"
      },
      "slotDurationOption": "{{minutes}} minit",
      "buttons": {
        "cancel": "Batal",
        "save": "Simpan Templat"
      },
      "toast": {
        "success": "Templat jadual disimpan",
        "failure": "Gagal menyimpan templat jadual"
      },
      "placeholders": {
        "templateName": "cth. Klinik Isnin Pagi"
      },
      "defaultName": "Jadual {{day}}"
    },
    "scheduleManagement": {
      "title": "Pengurusan Jadual",
      "backToDashboard": "← Papan Pemuka",
      "newTemplate": "Templat Baharu",
      "today": "Hari Ini",
      "blockTooltip": "{{start}} - {{end}} ({{state}})",
      "slotsLabel": "Slot {{minutes}} minit",
      "legend": {
        "booked": "Telah Ditempah"
      },
      "upcomingAppointmentsHeading": "Temu Janji Akan Datang - {{providerName}}",
      "loadingAppointments": "Memuatkan temu janji...",
      "unknownPatient": "Pesakit Tidak Diketahui",
      "fallbackAppointmentType": "Am",
      "noUpcomingAppointments": "Tiada temu janji akan datang untuk doktor ini"
    },
    "providerCoverage": {
      "title": "Liputan Doktor",
      "subtitle": "Liputan syif berhad waktu — serahkan panel pesakit anda kepada rakan sekerja untuk tempoh tertentu. Berbeza daripada break-glass; digunakan untuk cuti, giliran on-call, dan ketidakhadiran yang dirancang.",
      "actions": {
        "newCoverage": "Liputan Baharu",
        "cancel": "Batal"
      },
      "form": {
        "title": "Aturan liputan baharu",
        "labels": {
          "coveredProviderId": "Doktor yang diliputi",
          "coveringProviderId": "Doktor yang meliputi",
          "scope": "Skop",
          "from": "Dari",
          "until": "Hingga",
          "reason": "Sebab"
        },
        "placeholders": {
          "coveredProviderId": "Doktor yang panelnya diliputi",
          "coveringProviderId": "Doktor yang mengambil alih dalam tempoh",
          "reason": "cth. Cuti tahunan 22–29 Apr; liputan on-call hujung minggu"
        },
        "help": {
          "coveredProviderId": "Tanpa COVERAGE_ADMIN, ini mestilah diri anda sendiri.",
          "coveringProviderId": "Cari mengikut nama dan pilih — liputan tidak pernah diberikan kepada ID yang ditaip."
        },
        "aria": {
          "effectiveFromDate": "Tarikh mula berkuat kuasa",
          "effectiveFromTime": "Masa mula berkuat kuasa",
          "effectiveUntilDate": "Tarikh tamat berkuat kuasa",
          "effectiveUntilTime": "Masa tamat berkuat kuasa"
        },
        "buttons": {
          "cancel": "Batal",
          "create": "Cipta liputan"
        },
        "typeaheadEmpty": "Doktor tidak dijumpai"
      },
      "sections": {
        "mine": {
          "title": "Liputan Saya",
          "subtitle": "Liputan di mana saya adalah doktor yang meliputi atau diliputi.",
          "empty": "Tiada liputan dalam rekod."
        },
        "all": {
          "title": "Semua Liputan",
          "subtitle": "Setiap aturan liputan dalam organisasi. Paparan pentadbir.",
          "empty": "Tiada liputan di mana-mana. Sama ada berita baik atau penapis sudah lapuk."
        }
      },
      "list": {
        "coveringConnector": "meliputi",
        "groups": {
          "active": "Aktif ({{count}})",
          "planned": "Dirancang / Lampau ({{count}})",
          "revoked": "Dibatalkan ({{count}})"
        },
        "untilRevoked": "sehingga dibatalkan",
        "revokedPrefix": "Dibatalkan",
        "revokeTitle": "Batalkan"
      },
      "revokeDialog": {
        "title": "Batalkan liputan?",
        "description": "{{coveringProviderName}} tidak lagi akan meliputi {{coveredProviderName}}. Rekod kekal dalam jejak audit.",
        "confirm": "Batalkan",
        "reasonPlaceholder": "Mengapa liputan ini ditamatkan? (pilihan)"
      },
      "toast": {
        "created": "Liputan dicipta",
        "revoked": "Liputan dibatalkan",
        "invalid": "Liputan tidak sah — semak doktor dan tarikh",
        "forbidden": "Tidak dibenarkan mencipta liputan untuk doktor ini",
        "createFailed": "Gagal mencipta liputan",
        "revokeFailed": "Gagal membatalkan liputan"
      }
    },
    "appointments": {
      "title": "Temu Janji",
      "subtitle": "Jadual dan urus temu janji pesakit",
      "actions": {
        "refresh": "Segar semula",
        "schedule": "Jadualkan Temu Janji",
        "arriveTitle": "Rekod ketibaan",
        "arriveAria": "Rekod ketibaan {{patientName}}",
        "checkInTitle": "Daftar masuk",
        "checkInAria": "Daftar masuk {{patientName}}",
        "rescheduleTitle": "Jadualkan semula",
        "rescheduleAria": "Jadualkan semula {{patientName}}",
        "cancelTitle": "Batal",
        "cancelAria": "Batalkan temu janji {{patientName}}",
        "checkedInLabel": "Sudah daftar",
        "startVisitTitle": "Mulakan Kunjungan",
        "startVisitAria": "Mulakan kunjungan untuk {{patientName}}"
      },
      "weekNav": {
        "previous": "Minggu sebelum",
        "previousAria": "Minggu sebelum",
        "next": "Minggu seterusnya",
        "nextAria": "Minggu seterusnya"
      },
      "calendar": {
        "gridAria": "Kalendar temu janji mingguan",
        "timeColumn": "Masa",
        "loading": "Memuatkan jadual...",
        "cellAria": "{{dayLabel}} {{date}} pada {{time}}",
        "cellTitle": "{{patientName}} - {{appointmentType}} ({{status}})"
      },
      "upcoming": {
        "heading": "Temu Janji Akan Datang",
        "empty": "Tiada temu janji untuk minggu ini",
        "durationMinutes": "{{minutes}} min",
        "columns": {
          "dateTime": "Tarikh / Masa",
          "patient": "Pesakit",
          "type": "Jenis",
          "provider": "Doktor",
          "duration": "Tempoh",
          "status": "Status",
          "actions": "Tindakan"
        }
      },
      "toast": {
        "cancelled": "Temu janji dibatalkan",
        "cancelFailed": "Gagal membatalkan temu janji",
        "visitStarted": "Kunjungan dimulakan",
        "startVisitFailed": "Gagal memulakan kunjungan",
        "arrivalRecorded": "Ketibaan direkodkan",
        "arrivalFailed": "Gagal merekod ketibaan"
      }
    },
    "appointmentForm": {
      "title": {
        "create": "Jadualkan Temujanji Baharu",
        "edit": "Jadualkan Semula Temujanji"
      },
      "labels": {
        "patient": "Pesakit",
        "appointmentType": "Jenis Temujanji",
        "provider": "Doktor",
        "scheduledAt": "Masa Temujanji",
        "duration": "Tempoh",
        "reason": "Sebab Lawatan"
      },
      "placeholders": {
        "patientSearch": "Cari pesakit mengikut nama atau MRN...",
        "provider": "Nama doktor",
        "reason": "Sebab lawatan secara ringkas..."
      },
      "patientTypeahead": {
        "empty": "Pesakit tidak ditemui"
      },
      "aria": {
        "appointmentDate": "Tarikh temujanji",
        "appointmentTime": "Masa temujanji"
      },
      "durationOption": "{{minutes}} min",
      "buttons": {
        "cancel": "Batal",
        "schedule": "Jadualkan Temujanji",
        "update": "Kemas Kini Temujanji"
      },
      "toast": {
        "created": "Temujanji berjaya dijadualkan",
        "updated": "Temujanji dikemas kini",
        "createFailed": "Gagal mencipta temujanji",
        "updateFailed": "Gagal mengemas kini temujanji"
      },
      "validation": {
        "patientRequired": "Sila pilih pesakit",
        "appointmentTypeRequired": "Jenis temujanji diperlukan",
        "scheduledAtRequired": "Tarikh dan masa diperlukan",
        "durationInvalid": "Tempoh mestilah antara 1 dan 480 minit",
        "providerRequired": "Sila pilih doktor"
      },
      "providerTypeahead": {
        "empty": "Doktor tidak dijumpai"
      },
      "loadingEdit": "Memuatkan janji temu…",
      "loadEditError": "Janji temu ini tidak dapat dimuatkan.",
      "patientLocked": "Pesakit tidak boleh ditukar semasa menjadualkan semula."
    },
    "waitlist": {
      "title": "Senarai Menunggu Temu Janji",
      "backToDashboard": "← Papan Pemuka",
      "entryCount": "{{count}} entri",
      "searchPlaceholder": "Cari nama pesakit, MRN atau nota...",
      "clearSearchAria": "Kosongkan carian",
      "filters": {
        "allProviders": "Semua Doktor",
        "allTypes": "Semua Jenis",
        "providerAriaLabel": "Tapis mengikut doktor",
        "typeAriaLabel": "Tapis mengikut jenis temu janji"
      },
      "columns": {
        "patient": "Pesakit",
        "provider": "Doktor",
        "type": "Jenis",
        "priority": "Keutamaan",
        "requestedDates": "Tarikh Diminta",
        "dateAdded": "Tarikh Ditambah",
        "notes": "Nota",
        "actions": "Tindakan",
        "reason": "Sebab"
      },
      "priority": {
        "urgent": "Segera",
        "routine": "Rutin",
        "flexible": "Fleksibel"
      },
      "actions": {
        "scheduleTitle": "Jadualkan temu janji",
        "editPriorityTitle": "Sunting keutamaan",
        "removeTitle": "Buang dari senarai menunggu"
      },
      "empty": "Tiada entri senarai menunggu yang sepadan dengan penapis anda",
      "loadFailed": "Senarai menunggu tidak dapat dimuatkan. Semak sambungan anda dan cuba lagi.",
      "modal": {
        "title": "Jadualkan Temu Janji",
        "closeAria": "Tutup",
        "providerLabel": "Doktor:",
        "requestedLabel": "Diminta:",
        "dateTimeLabel": "Tarikh & Masa Temu Janji *",
        "dateAria": "Tarikh temu janji",
        "timeAria": "Masa temu janji",
        "requestedWindow": "Tetingkap yang diminta: {{start}} — {{end}}",
        "cancel": "Batal",
        "submit": "Jadualkan"
      },
      "toasts": {
        "removed": "Entri dibuang dari senarai menunggu",
        "priorityUpdated": "Keutamaan dikemas kini",
        "scheduled": "Temu janji dijadualkan dan dibuang dari senarai menunggu",
        "dateTimeRequired": "Sila pilih tarikh dan masa",
        "updateFailed": "Gagal mengemas kini senarai menunggu",
        "promoteOrphaned": "Temu janji telah dibuat tetapi entri senarai menunggu tidak dapat dikemas kini. Semak jadual sebelum mencuba lagi."
      }
    },
    "checkIn": {
      "title": "Daftar masuk pesakit",
      "subtitle": "Pendaftaran — insurans, kebenaran dan bayaran bersama. Pesakit telah tiba.",
      "fields": {
        "insuranceId": "Insurans",
        "copayAmount": "Jumlah bayaran bersama",
        "copayCollected": "Bayaran bersama diterima",
        "authorizationNumber": "Nombor kebenaran",
        "authorizationVerified": "Kebenaran disahkan"
      },
      "copayHint": "Menanda bayaran bersama diterima akan merekod pembayaran ke akaun pesakit.",
      "submit": "Lengkapkan pendaftaran",
      "cancel": "Batal",
      "toast": {
        "success": "Pesakit telah didaftarkan",
        "failed": "Gagal mendaftar masuk pesakit"
      }
    },
    "providerTypeahead": {
      "loadError": "Direktori doktor tidak tersedia — semak sambungan anda dan cuba lagi.",
      "retry": "Cuba lagi"
    }
  }
}
